import React from "react";
//#region redux
//#endregion
//#region types
import { ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CustomerConstants, IconDefinitionConstants } from "utils/constants";
import { CustomerAddressSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { HorizontalFormField, GroupSection, Toggle } from "components/common/wintForms";
import AddressSection from "./address";
//#endregion

const CustomerAddressSection: React.FC<CustomerAddressSectionProps> = ({ connect }) => {
  const isSameDeliveryAddressProps = connect("generalInfo.isSameDeliveryAddress");
  const fromRegistryFieldProps = connect("fromRegistry");

  const autogeneratedValues = fromRegistryFieldProps.value;

  return (
    <GroupSection
      header={TranslationKeys.Common.Address}
      icon={IconDefinitionConstants.WInvoiceSupplier2}
      navKey={CustomerConstants.SettingsNavKeys.Address}
    >
      <AddressSection
        connect={connect}
        parentName="billingAddress"
        title={TranslationKeys.Invoice.InvoiceAddress}
        autogeneratedValues={autogeneratedValues?.billingAddress}
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...isSameDeliveryAddressProps}
        label={TranslationKeys.Invoice.SameAsDeliveryAddress}
      />
      {!isSameDeliveryAddressProps.value && (
        <AddressSection
          connect={connect}
          parentName="deliveryAddress"
          title={TranslationKeys.Invoice.DeliveryAddress}
        />
      )}
    </GroupSection>
  );
};

export default CustomerAddressSection;
